export enum ProductLocalStoreAvailabilityEvent {
    UPDATE_CONCRETE = 'productLocalStoreAvailabilityShortInfo:update:concrete',
    FETCH_DATA = 'productLocalStoreAvailabilityShortInfo:fetch:data',
    UPDATE_DATA = 'productLocalStoreAvailabilityShortInfo:update:data',
    DISABLE = 'productLocalStoreAvailabilityShortInfo:disable',
}
